import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import UCSColors from "@ucs/Utils/UCSColors";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    titleTypographyProps: {
        weight: 500,
    },
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        padding: 0;
        line-height: 1.1;
    `,
};
productListFilterAccordionSectionStyles.checkBox = {
    typographyProps: {
        size: 18,
    },
    color: `${UCSColors.gray04}`,
    css: css`
        span[role="checkbox"] {
            &:focus {
                box-shadow: none !important;
            }
        }
    `,
};
productListFilterAccordionSectionStyles.checkBoxSelected = {
    typographyProps: {
        size: 18,
    },
    color: `${UCSColors.gray04}`,
    css: css`
        span[role="checkbox"] {
            &:focus {
                box-shadow: none !important;
            }
        }
    `,
};
